<template>
  <v-navigation-drawer
    :value="drawer"
    @input="$emit('update:drawer', $event)"
    app
    clipped
  >
    <v-list dense nav>
      <template v-if="!device.isDesktop">
        <v-list-item>
          <v-list-item-avatar>
            <v-avatar color="primary">
              <span class="white--text">
                {{
                  [user.name, user.lastname]
                    .map((name) => toLatin(name.charAt(0).toUpperCase()))
                    .join("")
                }}
              </span>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-title>
            {{ toLatin(user.name) }} {{ toLatin(user.lastname) }}
          </v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <language-selector
          v-if="canSeeLanguage && availableLanguages.length > 1"
          component-type="autocomplete"
          dense
          @setLang="$emit('set-lang', $event)"
          component-class="my-2"
        />
      </template>
      <template v-for="item in menu">
        <template v-if="item.child">
          <v-list-group no-action value="true">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-for="child in item.child">
              <v-list-item :to="child.to" link exact>
                <v-list-item-content>
                  <v-list-item-title>{{ translate(child.title) }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list-group>
        </template>
        <!-- SIDEBAR-->
        <v-list-item :to="item.to" v-else>
          <v-list-item-icon>
            <span
              v-if="
                (user.is_transferable == 1 && item.title == 'Локација') ||
                item.title == 'Lokacija'
              "
              ><v-icon>{{ item.icon }}</v-icon></span
            >
            <span v-else-if="item.title != 'Локација' || item.title == 'Lokacija'"
              ><v-icon>{{ item.icon }}</v-icon></span
            >
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <span
                v-if="
                  (user.is_transferable == 1 && item.title == 'Локација') ||
                  item.title == 'Lokacija'
                "
                >{{ translate(item.title) }}</span
              >
              <span v-else-if="item.title != 'Локација' || item.title == 'Lokacija'">
                {{ $t(item.title) }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <!-- Logout for mobile devices -->
      <template v-if="!device.isDesktop">
        <v-divider class="mt-4"></v-divider>
        <v-list-item @click="$emit('logout')" class="mt-2">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ $t("logout") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import LanguageSelector from "@/components/layout/LanguageSelector.vue";

export default {
  name: "AppNavigationDrawer",
  components: {
    LanguageSelector,
  },
  props: {
    drawer: {
      type: Boolean,
      required: true,
    },
    availableLanguages: {
      type: Array,
      default: () => [],
    },
    menu: {
      type: Array,
      required: true,
    },
  },
  computed: {
    restaurant() {
      return this.$store.state.restaurant;
    },
    company() {
      return this.$store.state.company;
    },
    websites() {
      return this.user?.restaurants || [];
    },
    user() {
      return this.$store.state.user.user;
    },
    canSeeLanguage() {
      return ["admin", "restaurant", "admin_delivery", "company"].includes(
        this.user?.type
      );
    },
  },
  methods: {
    setLang() {
      this.$emit("setLang");
    },
  },
};
</script>
